<template>
  <div
    class="ui dropdown labeled selection icon button login100-form-btn"
    style="display:inline-block; border-radius:25px; max-width:50px"
    ref="language_dropdown"
  >
    <i class="language icon" style="padding-top:16px;width: 60px;"></i>
    <span class="text" style="padding-top:5px;padding-left: 20px;">{{
      $t("language")
    }}</span>
    <div class="menu">
      <div
        class="item"
        v-for="language in languages"
        v-bind:key="language.code"
        v-on:click="change_language(language)"
      >
        <i v-bind:class="language.flag"></i>
        {{ $t(language.name) }}
      </div>
    </div>
  </div>
</template>
<script>
import i18n from "@/i18n";

export default {
  name: "LanguageLoginSelector",
  data() {
    return {
      languages: [
        { name: "spanish", code: "es", flag: "gt flag" },
        { name: "english", code: "en", flag: "us flag" },
        { name: "french", code: "fr", flag: "fr flag" },
      ],
    };
  },
  mounted() {
    window.jQuery(this.$refs.language_dropdown).dropdown({
      direction: "upward",
    });
  },
  methods: {
    change_language(language) {
      i18n.locale = language.code;
    },
  },
};
</script>
